import { TableV2Column } from 'components/Table/TableV2';
import { SearchConversationsItem } from '../types';
import { Campaign, CampaignType } from 'services/campaign/types';
import { ConversationFilterIds } from '../constants/enums';
import { SearchableConversationSortableFields } from 'generated-graphql/types';

export const filterConversationsColumn = ({
  hasCalendarMeeting,
  columns,
  campaign,
  hasApplicationSource
}: {
  hasCalendarMeeting: boolean;
  hasApplicationSource: boolean;
  columns: TableV2Column<SearchConversationsItem>[];
  campaign: Campaign;
}) => {
  return columns.filter((column) => {
    if (column.name === 'Meeting') {
      return hasCalendarMeeting;
    }

    if (
      column.id === ConversationFilterIds.screeningStatus ||
      column.id === ConversationFilterIds.applicationStage ||
      column.id === SearchableConversationSortableFields.PreferredAnswersScore
    ) {
      if (campaign.type === CampaignType.HUMAN_OUTREACH) return false;
    }

    if (column.name === 'Source') {
      return hasApplicationSource;
    }

    return true;
  });
};
